const optimizedPath = text => {
  if (text && text.includes('.svg'))
    return text;
  else
    return text ? text.replace(/\/app\/uploads\/([\w\/\.-]+?)(\s\d+w)?(\s|$)/g, '/app/compressx-nextgen/uploads/$1.webp$2 ') : null
}
export default optimizedPath
